interface VerbatimCandidate {
  status?: string | null
  is_version_2?: boolean
  is_latest_version?: boolean
  submitted_attachment?: unknown
  submitted_attachment_source?: string | null
}

// The lead payload names the file only by submitted_attachment_source, null when the caller can see none.
export const signsAsVerbatimRecord = (record: VerbatimCandidate): boolean =>
  record.is_version_2 !== true &&
  record.is_latest_version !== false &&
  (!!record.submitted_attachment || !!record.submitted_attachment_source)

export const isHeldForSigning = (record: { in_signing?: boolean }): boolean =>
  record.in_signing === true

// Mirrors ezbuild_back's is_client_deliverable: approved for a first send, sent for a repeat.
const DELIVERABLE_STATUSES: ReadonlySet<string> = new Set(["approved", "sent"])

/** A template-generated proposal or contract, whose fields follow its signature blocks. */
export const signsAsGeneratedRecord = (record: VerbatimCandidate): boolean =>
  record.is_version_2 === true &&
  record.is_latest_version !== false &&
  DELIVERABLE_STATUSES.has(record.status ?? "")

export const offersSendForSignature = (
  record: VerbatimCandidate & { in_signing?: boolean }
): boolean =>
  (signsAsVerbatimRecord(record) || signsAsGeneratedRecord(record)) &&
  !isHeldForSigning(record)
